<template>
  <v-container fluid>
    <v-row class="device_details" :class="!$route.params.deviceId ? '' : 'pl-3 pr-3'">
      <v-col cols="12" class="pa-0">
        <v-toolbar v-if="$route.params.deviceId" class="add-opacity" color="backgroundLight" flat>
          <v-toolbar-title class="title primaryGrey--text">
            <router-link :to="`/scavenger_h2`">
              <v-icon class="mr-3" color="primaryGrey">mdi-keyboard-backspace</v-icon>{{ $t("common.words.back") }}
            </router-link>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-col cols="12" md="3" v-if="$route.params.deviceId">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  dense
                  append-icon="mdi-calendar"
                  readonly
                  label="As of"
                  :value="computedAsOf"
                ></v-text-field>
              </template>
              <v-date-picker
                v-if="device_data"
                v-model="as_of"
                @change="duration.value >= 7 ? fetchStatsData() : getMessages()"
                :min="device_data.StatusDate"
                :max="device_data.LastMessageTime | epochToIso"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row v-if="device_data" class="common-card-row">
      <v-col cols="12" md="6">
        <v-row class="pa-0 pr-md-3 pb-3 pb-md-0">
          <v-col cols="12" class="common-card-col mb-3">
            <div class="d-flex font-weight-bold titleLight--text">
              {{ device_name }}

              <v-icon
                v-if="$route.params.deviceId && !is_readonly_user"
                color="primary"
                class="pl-2 pb-1 pointer"
                title="Edit Device Details"
                @click="
                  dialog = true;
                  overlay_type = 'edit';
                "
                small
                >mdi-pencil</v-icon
              >
              <v-icon
                v-if="$route.params.deviceId"
                color="vtred"
                class="pl-2 pb-1 pointer"
                title="Create alert"
                small
                @click="
                  dialog = true;
                  overlay_type = 'alert';
                "
                >mdi-bell-plus</v-icon
              >
              <router-link
                class="no-style"
                target="_blank"
                :to="`/scavenger_h2_report/${deviceId || $route.params.deviceId}`"
              >
                <v-icon color="vtblue" class="pl-2 pb-1 pointer" title="Report" small>mdi-file-document</v-icon>
              </router-link>
              <v-spacer></v-spacer>
              <AddToWatchlist v-if="device_id" :deviceId="device_id" />
            </div>
            <div class="text-caption primaryGrey--text">
              <TagsVT :device_id="device_id" />
            </div>
            <div v-if="device_data.CurrentLat" class="d-flex mt-1 text-caption primaryGrey--text">
              <div><v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon>{{ device_data.CurrentLat }}</div>
              <div class="ml-3">
                <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon>{{ device_data.CurrentLng }}
              </div>
            </div>
            <v-row class="mt-3" v-if="device_data">
              <v-col
                cols="4"
                class="pl-4 pt-1 font-weight-bold titleLight--text"
                v-for="(data, index) in page_content.device_details_h2"
                :key="index"
              >
                <div class="text-caption">
                  {{ data.label }}
                </div>
                <span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                <span v-else-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                <span
                  v-else-if="data.type == 'tooltip'"
                  :key="`tooltip-${data.value}-${device_data[data.value]}`"
                  :data-testid="`device-details-${data.value}`"
                  >{{ device_data[data.value] }}
                  <TooltipVT
                    v-if="device_data[data.tooltip_value]"
                    :text="getTooltipText(device_data, data)"
                    :icon="data.tooltip_icon"
                    size="large"
                  ></TooltipVT>
                </span>
                <span v-else>
                  {{ device_data[data.value] || "-" }}
                </span>
                <span v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="common-card-col">
            <v-row>
              <v-col>
                <div class="font-weight-bold titleLight--text">
                  {{ $t("views.ScavengerH2Details.latestMessage.title") }}
                  <span class="text-body-2">{{ device_data["LastMessageTime"] | epochCon }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pl-4" v-for="(data, index) in page_content.latest_message_h2" :key="index">
                <v-row no-gutters>
                  <v-col>
                    <div class="width-30 text-caption titleLight--text">
                      <v-icon small v-if="data.icon">{{ data.icon }}</v-icon>
                      <span v-if="data.pow" v-html="formattedLabel(data.label)"></span>
                      <span v-else>{{ data.label }}</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <div class="pr-4 text-h6 titleLight--text">
                      <span v-for="(coldata, idx) in data.values" :key="idx"
                        ><span v-if="data.type == 'datetime'">{{ device_data[coldata] | date }}</span>
                        <span v-if="data.type == 'date'">{{ $dateFormat(device_data[coldata]) }}</span>
                        <span
                          v-if="
                            data.type == 'lookup' &&
                            (!(coldata in device_data) || (device_data[coldata] && device_data['Status'] != 3))
                          "
                          :class="`${data.colors[idx]}--text`"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">Unknown</span>
                            </template>
                            <span
                              ><b>Status:</b> {{ page_content.Status[device_data["Status"]] }}<br /><b>Operation:</b
                              >{{ page_content.Operation[device_data["Operation"]] }}</span
                            >
                          </v-tooltip>
                        </span>
                        <!-- Apply the temperature metric filter to OilTemp specifically  according to powerdata user type-->
                        <span v-else-if="coldata === 'OilTemp'" :class="`${data.colors[idx]}--text`"
                          >{{ device_data[coldata] | toUserSelectedTempMetric }}
                        </span>
                        <span v-else :class="`${data.colors[idx]}--text`">
                          {{ device_data[coldata] | round(data.round) }}
                        </span>
                        <span class="text-caption" v-if="data.suffix && device_data[coldata]">{{ data.suffix }}</span
                        ><span v-if="idx != data.values.length - 1"> /</span></span
                      ><span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                      <span v-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                      <span v-else>
                        {{ device_data[data.value] }}
                      </span>
                      <span class="text-caption font-weight-light" v-if="data.helptext">{{ data.helptext }}</span>
                      <span class="text-caption" v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="pa-0">
        <v-col cols="12" class="common-card-col">
          <MapsVT
            height="35vh"
            :options="page_content.maps_config"
            :infoWindowItemsConfig="page_content.infoWindowItemsConfig"
            :items="map_data"
            :center="get_center"
            :showRoute="!show_info_window"
            :hide_legends="show_info_window"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="common-card-row">
      <v-col class="common-card-col mb-3">
        <v-card class="d-flex justify-space-between backgroundWhite" flat>
          <div>
            <PrimaryFiltersVT
              :list_filters="tabs"
              @filter_update="updateCurrentTab($event)"
              :current_tab="current_tab"
            />
          </div>
          <div v-if="page_content && current_tab == 'Charts'" class="pt-2">
            <DatePickerVT @updatePeriod="updatePeriod" :is_loading="is_loading" />
          </div>
        </v-card>
        <v-row no-gutter class="mt-3">
          <v-col cols="12">
            <v-row no-gutters class="primaryDark--text" v-if="current_tab == 'Charts'">
              <v-col cols="12">
                <div v-if="chart_data">
                  <LightningChartVT
                    :chart_data="chart_data"
                    :config="page_content.scavenger_charts"
                    :charts="charts"
                    :visible_charts="charts"
                    :types="types"
                    :visible_types="visible_types"
                    :weather_charts_visibility="weather_charts_visibility"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="primaryDark--text" v-if="current_tab == 'Messages'">
              <v-col cols="12">
                <DataTableVT
                  :headers="page_content.messages_table_h2"
                  sort_by="Timestamp"
                  :items_list="message_list"
                  :no_search="no_search"
                  :custom_pagination="table_pagination"
                  :loading="is_loading"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="primaryDark--text pa-4" v-if="current_tab == 'GasAnalysis'">
              <GasAnalysis :deviceId="device_id" :config="page_content.gas_analysis" :loading="is_loading" />
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
    <CustomOverlay
      v-if="dialog"
      show_header
      background_color="backgroundWhite"
      header_color="backgroundWhite"
      :width="`${overlay_type == 'alert' ? '450px' : '80vw'}`"
      @close="closeDialog"
    >
      <template v-slot:content>
        <EditH2Details
          @cancel="dialog = false"
          @save="updateAssetsDetails($event)"
          :asset_data="{ item: device_data }"
          v-if="device_data && overlay_type == 'edit'"
        />
        <ScvAlertsTemplate v-if="overlay_type == 'alert'" :device_id="device_id" @close="closeDialog($event)" />
      </template>
    </CustomOverlay>
  </v-container>
</template>

<script>
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import MapsVT from "../components/MapsVT";
import DataTableVT from "../components/DataTableVT";
import EditH2Details from "../components/EditH2Details.vue";
import { content } from "../../config/scavenger_h2.js";
import { axios_get, axios_post, axios_put } from "../services/vt_service";
import LightningChartVT from "../components/LightningChartVT";
import DatePickerVT from "../components/DatePickerVT.vue";
import GasAnalysis from "../components/GasAnalysis";
import ScvAlertsTemplate from "../components/ScvAlertsTemplate.vue";
import TooltipVT from "../components/TooltipVT";
import { h2, scv, weather, trafo } from "../services/powerdata";
import moment from "moment";
import store from "../store";
import CustomOverlay from "../components/CustomOverlay";
import TagsVT from "../components/TagsVT";
import AddToWatchlist from "../components/AddToWatchlist";

export default {
  props: { deviceId: String, asset_detail_data: Object },
  name: "ScavengerH2Details",
  components: {
    PrimaryFiltersVT,
    MapsVT,
    DataTableVT,
    EditH2Details,
    GasAnalysis,
    ScvAlertsTemplate,
    DatePickerVT,
    LightningChartVT,
    TooltipVT,
    CustomOverlay,
    TagsVT,
    AddToWatchlist,
  },
  watch:{
    page_content(newVal){
      if(newVal){
        this.initializeH2DetailsPage();
      }
    }
  },
  data: function () {
    return {
      is_loading: false,
      no_search: true,
      current_tab: "Charts",
      device_data: null,
      chart_data: null,
      device_id: null,
      tabs: [
        {
          value: "Charts",
          label: this.$t("views.ScavengerH2Details.tabs.charts.label"),
        },
        {
          value: "Messages",
          label: "Raw Data",
        },
        {
          value: "GasAnalysis",
          label: this.$t("views.ScavengerH2Details.tabs.gasAnalysis.label"),
        },
      ],
      show_info_window: true,
      dialog: false,
      duration: null,
      overlay_type: null,
      error_message: null,
      snackbar: false,
      as_of: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      message_list: null,
      table_pagination: null,
      charts: ["H2", "OilTemperature", "Moisture", "Pressure", "AmbientTemperature"],
      h2_charts: ["H2", "OilTemperature", "Moisture", "Pressure"],
      ambient_temperature_chart: ["AmbientTemperature"],
      types: ["Mean"],
      visible_types: ["Mean"],
      weather_charts_visibility: {
        AmbientTemperature: true, //should be shown by default
      },
    };
  },
  async mounted() {
    if (!this.$store.getters.getPowerDataType) {
      await this.$store.dispatch("fetchPowerdataType");
    }
    if(this.page_content){
      this.initializeH2DetailsPage();
    }
  },
  methods: {
    async initializeH2DetailsPage(){
    this.table_pagination = this.page_content.table_pagination;
    this.device_id = this.deviceId || this.$route.params.deviceId;

    const new_data = await this.getChartData();
    let temperature_data = await this.getAmbientTempData();
    const temperature_chart_data = this.formatChartData(temperature_data, this.ambient_temperature_chart);
    let h2_charts = this.formatChartData(new_data);
    h2_charts.AmbientTemperature = temperature_chart_data.AmbientTemperature;
    this.chart_data = h2_charts; //this.formatChartData(new_data);
    this.getAssetDetails();
    this.getMessages();
    },
    formattedLabel(label) {
      return label.replace(/2/, "<sub>2</sub>");
    },
    closeDialog() {
      this.dialog = false;
      this.overlay_type = "";
    },
    updateCurrentTab(val) {
      this.current_tab = val;
    },
    async getAssetDetails() {
      let h2_response = await axios_get(h2.get_scv_h2_asset, { id: this.device_id });
      const pq_response = this.$store.state.is_pq_enabeled
        ? await axios_get(scv.get_scavenger_data, { id: this.device_id })
        : [{}];
      let res = { ...h2_response[0], ...pq_response[0] };
      this.device_data = res;
    },
    async getMessages() {
      this.is_loading = true;
      let start_date = this.$timestampToEpoch(new Date(new Date(this.as_of).getTime() + 60 * 60 * 24 * 1000 - 1));
      let duration = 1; //this.duration.value; // TODO: This should be come from the duration picker
      let response = await axios_get(h2.get_scv_h2_mesg, {
        id: this.device_id,
        duration,
        start_date,
        // We can pass end_date as well if we want to get messages between two dates
      });
      //Dynamically format temperature value based on user type
      let formatted_response = JSON.parse(JSON.stringify(response));
      formatted_response = formatted_response.map((e) => {
        if (e.OilTemp !== undefined) {
          e.OilTemp = parseFloat(this.$options.filters.toUserSelectedTempMetric(e.OilTemp));
        }
        return e;
      });
      this.message_list = formatted_response;
      this.is_loading = false;
    },
    async getChartData(parameters) {
      this.is_loading = true;
      const params = {
        start_date: null,
        end_date: null,
        aggregation: null,
        charts: this.h2_charts,
        types: this.types,
      };
      if (parameters) {
        Object.keys(parameters).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            params[key] = parameters[key];
          }
        });
      }
      const response = await axios_get(h2.get_h2_chart_data, { id: this.device_id }, params);
      this.is_loading = false;
      return response;
    },
    async updatePeriod(e) {
      const parameters = {
        start_date: e.start_date,
        end_date: e.end_date,
        aggregation: e.aggregation,
        types: this.types,
      };

      const period_data = await this.getChartData(parameters);
      const temp_parameters = {
        start_date: e.end_date,
        end_date: e.start_date,
      };
      const ambient_temp_period_data = await this.getAmbientTempData(temp_parameters);
      const temperature_chart_data = this.formatChartData(ambient_temp_period_data, this.ambient_temperature_chart);
      let h2_charts = this.formatChartData(period_data);
      // Append AmbientTemperature from temperature_chart_data to h2charts
      h2_charts.AmbientTemperature = temperature_chart_data.AmbientTemperature;
      this.chart_data = h2_charts;
    },
    formatChartData(data, format_charts = this.charts, type) {
      if (!data) return null;
      const types = type ? [type] : this.types;
      const formatted_data = {};

      format_charts.forEach((chart) => {
        const charts = [];
        const chart_config = this.page_content.scavenger_charts[chart];
        types.forEach((type) => {
          chart_config.values.forEach((value) => {
            const value_id = value ? `${value}_${chart_config.id}${type}` : `${chart_config.id}`;
            //Assign chart suffix as per user selected Temperature metric
            if (chart_config.isTemperature) {
              chart_config.suffix = this.$options.filters.temperatureSuffix();
            }
            const chart_data = {
              id: value_id,
              config_id: chart,
              type: type,
              value: value,
              label: `${value} ${chart_config.label} ${type}`,
              values: {
                xValues: data.map((e) => moment(e.Timestamp).valueOf()),
                yValues: data.map((e) => Number(this.getDataPointValue(e, value_id, chart_config))),
              },
            };
            charts.push(chart_data);
          });
        });
        formatted_data[chart] = charts;
      });
      return formatted_data;
    },
    async updateAssetsDetails(data) {
      this.dialog = false;
      const { DeviceID, TransformerRating } = data;
      await axios_post(scv.update_scv_details, data, { DeviceID: DeviceID });
      if (
        this.$store.state.is_pq_enabeled &&
        TransformerRating &&
        this.device_data.TransformerRating != TransformerRating
      ) {
        await axios_put(trafo.update_assets_details, { DeviceID }, { PowerRating: TransformerRating });
      }
      this.error_message = "Device Details Successfully Saved!";
      this.device_data.SiteName = data.SiteName;
      this.device_data.AssetID = data.AssetID;
      this.device_data.alarm = data.alarm;
      this.device_data.caution = data.caution;
      this.device_data.CurrentLat = data.CurrentLat;
      this.device_data.CurrentLng = data.CurrentLng;
      this.device_data.Comment = data.Comment;
      this.device_data.SensorType = data.SensorType;
      this.device_data.SensorLocation = data.SensorLocation;
      this.snackbar = true;
      this.$store.dispatch("loadH2Devices");
    },
    getTooltipText(data, config) {
      return config.tooltip_value
        ? config.tooltip_text + this.$options.filters.date(data[config.tooltip_value])
        : config.tooltip_text;
    },
    getDataPointValue(value, value_id, config) {
      if (config.isTemperature) {
        return value[value_id] ? this.$options.filters.toUserSelectedTempMetric(value[value_id]) : null;
      }
      return value[value_id] ? parseFloat(value[value_id]) : null;
    },
    updateTemperatureSuffix(content) {
      content.latest_message_h2.forEach((item) => {
        if (item.isTemperature) {
          item.suffix = this.$options.filters.temperatureSuffix();
        }
      });
      return content;
    },
    async getAmbientTempData(parameters) {
      let params = {};
      params.chart_type = "Temperature";
      params.device_id = this.device_id;
      if (!parameters) {
        params.start_date = moment().subtract(24, "hours").valueOf();
        params.end_date = moment().valueOf();
      } else {
        params.start_date = moment(parameters.end_date).valueOf();
        params.end_date = moment(parameters.start_date).valueOf();
      }
      let response = await axios_get(weather.fetch_weather_data, params);
      response.forEach((entry, index) => {
        response[index] = {
          Timestamp: entry.messagetimestamp,
          Temperature: entry.temperature.toString(), // Ensure it's a string as in your example
        };
      });
      return response;
    },
  },
  computed: {
    page_content(){
      //Assign temperature chart suffix as per user selected unit
      let updated_content = this.$store.state.user_config.temperature_metric? this.updateTemperatureSuffix(content):content;
      return updated_content;
    },
    computed_location_details() {
      let temp_obj = JSON.parse(JSON.stringify(this.device_data));
      return temp_obj;
    },
    map_data: function () {
      return this.computed_location_details.CurrentLat ? [this.computed_location_details] : [];
    },
    get_center: function () {
      return this.map_data
        ? new window.google.maps.LatLng(
            this.computed_location_details.CurrentLat,
            this.computed_location_details.CurrentLng
          )
        : null;
    },
    computedAsOf() {
      return this.as_of ? this.$formatDateAsOf(this.as_of) : null;
    },
    device_name() {
      let name = null;
      if (this.device_data)
        if (this.device_data.SiteName && this.device_data.AssetID)
          name = `${this.device_data.SiteName}/${this.device_data.AssetID}`;
        else if (this.device_data.SiteName || this.device_data.AssetID)
          name = this.device_data.SiteName ? this.device_data.SiteName : this.device_data.AssetID;
        else name = this.device_data.DeviceID;
      return name;
    },
    is_readonly_user: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("ReadOnlyUser") != -1 ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.device_details {
  .title {
    font-size: 0.75rem !important;
    font-family: Trade Gothic Regular !important;
  }
}

.border-bottom {
  border-bottom: 1px solid var(--v-restingOutline-base);
}

.border-right {
  border-right: 1px solid var(--v-restingOutline-base);
}

.duration_select_div {
  .duration_select {
    width: 9em;
    margin-right: 1em;
  }

  .asset_select {
    width: 25em;

    .v-input {
      max-width: 80%;
    }
  }

  ::v-deep.show-ambient-temp {
    label {
      margin-bottom: 0 !important;
    }
  }
}

::v-deep .export-div {
  top: 25px;
  right: 2rem;
}

.pointer {
  cursor: pointer;
}

.card-title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
  color: var(--v-primary-base);
  margin-bottom: 0;
}
</style>
